// extracted by mini-css-extract-plugin
module.exports = {"buttons":"LaunchBarSettings-module__buttons___Pckl5","settings":"LaunchBarSettings-module__settings___1k48U"};